export default __webpack_public_path__ + "static/media/greenDeploymentManager.bd2d3cab.svg";